import {
  cancelContactPortalInvitation,
  createContactPortalInvitation,
  retrieveContactPortalAccess,
  revokeContactPortalAccess,
  resendContactPortalInvitation,
} from "@/lib/data/requests/contacts/contact-portal-access";
import { queryKeys } from "@/lib/data/static/query-keys";
import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

const portalAccessKey = (contactId: string) => [
  queryKeys.contactPortalAccess,
  contactId,
];

export const contactPortalAccessQueryOptions = (contactId: string) =>
  queryOptions({
    queryKey: portalAccessKey(contactId),
    queryFn: () => retrieveContactPortalAccess(contactId),
    enabled: Boolean(contactId),
  });

export const useContactPortalAccess = (contactId: string, enabled: boolean) =>
  useQuery({
    ...contactPortalAccessQueryOptions(contactId),
    enabled: enabled && Boolean(contactId),
  });

export const useCreateContactPortalInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createContactPortalInvitation,
    onSuccess: async (_result, { contactId }) => {
      await queryClient.invalidateQueries({
        queryKey: portalAccessKey(contactId),
      });
    },
  });
};

export const useRevokeContactPortalAccess = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: revokeContactPortalAccess,
    onSuccess: async (_result, contactId) => {
      await queryClient.invalidateQueries({
        queryKey: portalAccessKey(contactId),
      });
    },
  });
};

export const useCancelContactPortalInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: cancelContactPortalInvitation,
    onSuccess: async (_result, { contactId }) => {
      await queryClient.invalidateQueries({
        queryKey: portalAccessKey(contactId),
      });
    },
  });
};

export const useResendContactPortalInvitation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: resendContactPortalInvitation,
    onSuccess: async (_result, { contactId }) => {
      await queryClient.invalidateQueries({
        queryKey: portalAccessKey(contactId),
      });
    },
  });
};
